import * as React from 'react';
import { StyledLabel } from '../common';

interface TextCellContentProps {
  value: string;
}

export const TextCellContent: React.FunctionComponent<TextCellContentProps> = ({ value }: TextCellContentProps) => {
  return <StyledLabel>{value}</StyledLabel>;
};
